// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Kcwb","clinicsSelect":"styles_clinicsSelect__IxHhm"};